<ng-container>
  <div *ngIf="displayErrors" class="errorMessage">
    <span [innerHTML]="errorMessage" class="mesageContent"></span>
    <i class="fas fa-times closeIcon" (click)="cancelClick()"></i>
  </div>
  <div *ngIf="displaySuccesses" class="successMessage">
    <span [innerHTML]="successMessage" class="mesageContent"></span>
    <i class="fas fa-times closeIcon" (click)="cancelClick()"></i>
  </div>
  <div *ngIf="displayInformation" class="infoMessage">
    <span [innerHTML]="infoMessage" class="mesageContent"></span>
    <i class="fas fa-times closeIcon" (click)="cancelClick()"></i>
  </div>
</ng-container>